export function getLocalStorageValue(key) {
    var val = localStorage.getItem(key);
    if (!val) {
        return null;
    }
    try {
        return JSON.parse(val);
    }
    catch (e) {
        return null;
    }
}
export function setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
